import { ImageRecord, MonitoringImage } from './cctv-monitoring.models';

export function normalizeImage(record: ImageRecord, baseUrl: string): MonitoringImage | null {
  if (!record || typeof record !== 'object') return null;
  const unitId = String(record.strUnitID || record.strIMEI || '').trim();
  const fileName = String(record.strFileName || '').trim().replace(/\\/g, '/').split('/').pop()!
    .replace(/^(?:EVENT|CMD)_\d{15}_[^_]+_/i, '');
  const originalUrl = String(record.strImageURL || '').trim();
  const suffix = (fileName || originalUrl).match(/_([IFO])_\d+(?:_t)?\.jpe?g(?:[?#].*)?$/i);
  const rawCategory = String(record.strCategory || '').toUpperCase();
  const kind = suffix ? suffix[1].toUpperCase() : rawCategory;
  const category = kind === 'I' || kind.startsWith('I_') || kind === 'CABIN' ? 'cabin'
    : kind === 'F' || kind === 'O' || kind.startsWith('F_') || kind.startsWith('O_') || kind === 'OUTSIDE' || kind === 'ROAD' ? 'outside' : null;
  if (!unitId || !category || (!fileName && !originalUrl)) return null;

  const path = fileName ? `${baseUrl}/jc261/${encodeURIComponent(unitId)}/images/` : '';
  const fullUrl = originalUrl ? originalUrl.replace(/_t(\.jpe?g)(?=[?#]|$)/i, '$1')
    : path + encodeURIComponent(fileName.replace(/_t(\.jpe?g)$/i, '$1'));
  const thumbnailUrl = fullUrl.replace(/(?:_t)?(\.jpe?g)(?=[?#]|$)/i, '_t$1');
  return {
    unitId, name: String(record.strFullName || unitId), plate: String(record.strVehicleNo || ''), category,
    thumbnailUrl, fullUrl, date: String(record.dtImageDateTime || ''),
    ageText: String(record.strImageTimeAge || ''), speed: record.iSpeed ?? record.fSpeed ?? record.strSpeed ?? null,
  };
}

export function imageAge(image: MonitoringImage): number | null {
  const timestamp = Date.parse(image.date);
  return Number.isFinite(timestamp) ? Math.max(0, Math.floor((Date.now() - timestamp) / 1000)) : null;
}
